import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { FONT_WEIGHT_MEDIUM } from '../../../styles/rn';
import { Dimensions, StyleSheet } from 'react-native';
var Styles = CustomStyleSheet({
  'contact-courier-card': {
    width: '100%',
    backgroundColor: '#ffffff'
  },
  'contact-courier-card-header': {
    height: 48,
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0, 0, 0, 0.09)'
  },
  'contact-courier-card-header-pic-container': {
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.09)',
    borderWidth: 0.5,
    width: 24,
    height: 24,
    borderRadius: 100,
    margin: 0,
    marginHorizontal: 8,
    marginRight: 8,
    marginLeft: 12
  },
  'contact-courier-card-header-pic': {
    width: 24,
    height: 24,
    borderRadius: 100,
    backgroundColor: '#fafafa'
  },
  'contact-courier-card-header-title': _objectSpread({
    fontWeight: '500',
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  }, FONT_WEIGHT_MEDIUM),
  'contact-courier-card-content': {
    width: '100%',
    paddingBottom: 12
  },
  'contact-courier-card-content-top': {
    height: 34,
    marginTop: 12,
    marginBottom: 0,
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 12
  },
  'contact-courier-card-content-top-pic': {
    width: 34,
    height: 34,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: 'rgba(0, 0, 0, 0.09)',
    borderRadius: 4,
    flexShrink: 0
  },
  'contact-courier-card-content-top-order': {
    // borderWidth: 1,
    // borderColor: 'rgba(0, 0, 0, 0.09)',
    borderRadius: 8,
    flexShrink: 0,
    flex: 1,
    marginLeft: 5.2,
    marginRight: 16,
    // minWidth: 0,
    height: '100%'
  },
  'contact-courier-card-content-top-order-text': {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  'contact-courier-card-content-top-order-text-copy': {
    color: 'rgba(0, 0, 0, 0.65)',
    fontWeight: '400',
    fontSize: 12,
    marginRight: 2
  },
  'contact-courier-card-content-top-order-text-icon': {
    height: 16,
    width: 16
  },
  'contact-courier-card-content-top-order-status': _objectSpread({
    fontWeight: '500',
    fontSize: 14,
    color: '#26aa99'
  }, FONT_WEIGHT_MEDIUM),
  'contact-courier-card-content-top-track': {
    borderWidth: 1,
    borderColor: '#26aa99',
    borderRadius: 100,
    textAlign: 'center',
    flex: 0,
    paddingHorizontal: 10,
    marginLeft: 10
  },
  'contact-courier-card-content-top-track-text': _objectSpread({
    height: 30,
    lineHeight: 30,
    color: '#26aa99',
    fontWeight: '500',
    fontSize: 12
  }, FONT_WEIGHT_MEDIUM),
  'contact-courier-card-content-center': {
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    display: 'flex',
    paddingVertical: 8,
    paddingHorizontal: 12,
    margin: 12,
    marginTop: 12,
    marginBottom: 0,
    alignItems: 'center',
    flexDirection: 'row'
  },
  'contact-courier-card-content-center-left': {
    flex: 1
  },
  'contact-courier-card-content-center-left-name': _objectSpread(_objectSpread({
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 20
  }, FONT_WEIGHT_MEDIUM), {}, {
    color: 'rgba(0, 0, 0, 0.87)'
  }),
  'contact-courier-card-content-center-left-tip': {
    marginTop: 4,
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'contact-courier-card-content-center-right': {
    width: 40,
    height: 40,
    marginLeft: 8,
    flexShrink: 0
  },
  'contact-courier-card-content-center-right-call': {
    width: '100%',
    height: '100%'
  },
  'contact-courier-card-content-bottom': {
    lineHeight: 12,
    paddingTop: 12,
    paddingHorizontal: 12
  },
  'contact-courier-card-content-bottom-text': {
    color: 'rgba(0, 0, 0, 0.54)',
    fontWeight: '400',
    fontSize: 10
  },
  'contact-courier-card-content-button-text': {
    color: 'rgba(0, 0, 0, 0.65)',
    fontSize: 12,
    textAlign: 'center'
  },
  'contact-courier-card-content-button-link': {// padding: 0,
  },
  'contact-courier-card-content-button-link-a': {
    color: 'rgba(0, 0, 0, 0.65)',
    textDecorationLine: 'none',
    display: 'flex',
    width: '100%',
    height: '100%',
    paddingVertical: 8,
    paddingHorizontal: 12
  },
  'contact-courier-card-content-buttons': {
    paddingHorizontal: 12,
    justifyContent: 'space-between'
  },
  'contact-courier-card-popup-cancel': {
    fontWeight: '400',
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    height: 52,
    lineHeight: 52,
    textAlign: 'center',
    backgroundColor: '#ffffff'
  },
  'contact-courier-card-popup-gap': {
    backgroundColor: '#f5f5f5',
    height: 12
  },
  'contact-courier-card-popup-link': {
    height: 40,
    textAlign: 'center',
    lineHeight: 32,
    padding: 0,
    margin: 0,
    paddingHorizontal: 12,
    marginLeft: 0,
    marginRight: 0
  },
  'contact-courier-card-popup-content': {
    padding: 0
  }
});
var margin = Dimensions.get('window').width <= 360 ? 4 : 8;
export var GenerateStyles = function GenerateStyles(idx) {
  return {
    'contact-courier-card-content-button-container': {
      borderWidth: 1,
      borderColor: 'rgba(0, 0, 0, 0.09)',
      borderRadius: 100,
      margin: 0,
      flex: 1,
      paddingVertical: 8,
      paddingHorizontal: 12,
      marginTop: 8,
      marginHorizontal: 0,
      marginVertical: 0,
      marginLeft: idx === 0 ? 0 : margin
    }
  };
};
export default Styles;